import React, { JSX, useState } from 'react';
import Icons from 'components/atoms/Icons';
import { OnQueryInputChangeType } from 'components/types/FilterTypes';

type SearchTypeaheadProps = {
  minimumCharacters: number;
  onQueryInputChange: OnQueryInputChangeType;
  placeholder: string;
  queryInputValue: string;
  searchType: string;
  updateQuery: Function;
  isMobile?: boolean;
};

// TEMP hardcoded suggestions until backend typeahead is wired up
const HARDCODED_SUGGESTIONS = [
  'Heart Awareness',
  'Heart Health',
  'Heart Health Recipes',
  'Heart Institute',
  'Heart Specialties',
  'Cancer Care',
  'Primary Care',
  'Pediatrics',
  'Orthopedics',
  'Women\'s Health',
];

const SearchTypeahead = (props: SearchTypeaheadProps): JSX.Element => {
  const [suggestions, setSuggestions] = useState<string[]>([]);
  // const getSuggestions = (value: string) => {
  //   const inputValue = value.trim().toLowerCase();
  //   const inputLength = inputValue.length;
  //   return inputLength > props.minimumCharacters ? suggestions : [];
  // };

  // const getSuggestionValue = (suggestion: string) => {
  //   return htmlDecode(suggestion.match);
  // };

  // const htmlDecode = (input: any) => {
  //   let div = document.createElement('div');
  //   div.innerHTML = input;
  //   return div.textContent || div.innerText || '';
  // };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      submitSearch();
    }

    if (e.key === 'Escape') {
      setSuggestions([]);
    }
  };

  const onChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    props.onQueryInputChange(newValue);

    if (
      newValue.length >= props.minimumCharacters &&
      props.searchType !== 'locations'
    ) {
        const filtered = HARDCODED_SUGGESTIONS.filter((s) =>
          s.toLowerCase().includes(newValue.toLowerCase())
        ).slice(0, 5);
        setSuggestions(filtered);
    } else {
      setSuggestions([]);

       // const endpoint = `${Constants.api.baseUrl}/providers?sc_apikey=${encodeURIComponent(
      // 	Constants.api.scApiKey
      // )}`;
      // const query = gql`
      // 	query GetSuggestions($input: String!, $typeaheadType: TypeaheadType) {
      // 		typeahead(input: $input, typeaheadType: $typeaheadType) {
      // 			match
      // 			url
      // 		}
      // 	}
      // `;
      // const variables = {
      // 	input: newValue,
      // 	typeaheadType: props.searchType == 'providers' ? 'PROVIDER' : 'LOCATION',
      // };
      //const { data } = await rawRequest(endpoint, query, variables);
      //setSuggestions(data.typeahead);
    }
  };

   // const onSuggestionsFetchRequested = ({ value }: any) => {
  //   setSuggestions(getSuggestions(value));
  // };

  // const onSuggestionsClearRequested = () => {
  //   setSuggestions([]);
  // };

  // const onSuggestionSelected = (_event: any, { suggestion }: any) => {
  //   if (suggestion.url) {
  //     window.location = suggestion.url;
  //   }
  // };

  const submitSearch = () => {
    setSuggestions([]);
    props.updateQuery(props.queryInputValue);
  };

  const highlightMatch = (text: string, query: string): string => {
    if (!query) return text;
    const idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return text;
    const before = text.slice(0, idx);
    const match = text.slice(idx, idx + query.length);
    const after = text.slice(idx + query.length);
    return `${before}<strong>${match}</strong>${after}`;
  };

  const { placeholder, queryInputValue } = props;

  return (
    <div className="input-icon-container">
      <input
        autoFocus={true}
        placeholder={placeholder}
        value={queryInputValue}
        onChange={onChange}
        onKeyDown={onKeyDown}
        //className="location-search-input"
        type="text"
      />

      {!props.isMobile &&
        queryInputValue.length >= props.minimumCharacters &&
        suggestions.length > 0 && (
          <div className="react-autosuggest__suggestions-container">
            {suggestions.map((suggestion: string, index: number) => (
              <div
                key={index}
                className="typeahead-suggestion"
                onClick={() => {
                  props.onQueryInputChange(suggestion);
                  props.updateQuery(suggestion);
                  setSuggestions([]);
                }}
              >
                <span
                  className="suggestion-name"
                  dangerouslySetInnerHTML={{
                    __html: highlightMatch(suggestion, queryInputValue),
                  }}
                ></span>
              </div>
            ))}
          </div>
        )}

      {props.queryInputValue && (
        <div
          className="close-button"
          onClick={() => {
            props.updateQuery('');
            setSuggestions([]);
          }}
        >
          <Icons id="close" className="icon icon-close" aria-hidden="true" />
        </div>
      )}
    </div>
  );
};

export default SearchTypeahead;